import { FirebaseProvider, useFirebase, withFirebaseHOC } from "../context";

import Firebase from "./firebase";

export default Firebase;

export { FirebaseProvider, useFirebase, withFirebaseHOC };
